export default __webpack_public_path__ + "aba3ccbeb5f876e6a8065740cdab7664.png";